import React, { useContext } from 'react'
import classes from './Cart.module.css'
import Modal from '../UI/Modal'
import CartContext from '../../Store/cart-context'
import CartItem from './CartItem';
export default function Cart(props) {
  const cartCtx = useContext(CartContext);
  console.log("this is the item ",cartCtx.items)
  const totalAmount = `${cartCtx.totalAmount.toFixed(2)}`;
  const hasItem = cartCtx.items.length > 0;

  const cartItemRemoveHandler = (id)=>{
    cartCtx.removeItem(id);
  };
  const cartItemAddHandler = (item)=>{
    cartCtx.addItem({...item , amount : 1});
  };



  const cartItems = (
  <ul className={classes['cart-items']}>
    {cartCtx.items.map((item)=>(
      <CartItem 
      key = {item.id} 
      name={item.name} 
      amount={item.amount} 
      price={item.price} 
      onRemove ={cartItemRemoveHandler.bind(null , item.id)} 
      onAdd={cartItemAddHandler.bind(null , item)}/>
    ))}
  </ul>)
  return (
    <Modal onClose={props.onClose}>
      {cartItems}
    <div className={classes.total}>
      <span>Total Amount</span>
      <span>₹{totalAmount}</span>
    </div>
    <div className={classes.actions}>
      <button className={classes.button} onClick={props.onClose}>Close</button>
    { hasItem &&  <button className={classes["button--alt"]}>Order</button>}</div>
    </Modal>
  )
}
